module.exports = __webpack_public_path__ + "img/paopaoH5.a8698a88.jpeg";